module.exports = __webpack_public_path__ + "img/shopping.fa2d90bc.svg";